import React from 'react'

class Staff extends React.Component {
  render() {
    // const {user} = this.props;
    return (
      <div style={{display: 'flex', justifyContent: 'center'}}>

          <img src="../underConstruction.png" alt=""/>

      </div>
    )
  }
}

export default Staff;

